import { type FC, type ReactNode } from 'react'

import { useSrpAds } from '@/components-page/srp/advertisement/useSrpAds'
import { AdsWrapper } from '@/features/advertisement/components/ads-wrapper/AdsWrapper'
import { prebidConfig } from '@/features/advertisement/components/prebid/prebidConfig'

type SearchAdsWrapperProps = {
  children: ReactNode
  isDesktopMapView: boolean
  isMobileMapView: boolean
}

export const SearchAdsWrapper: FC<SearchAdsWrapperProps> = ({
  children,
  isDesktopMapView,
  isMobileMapView,
}) => {
  const { srpGptConfig } = useSrpAds(isDesktopMapView, isMobileMapView)

  return (
    <AdsWrapper gptConfig={srpGptConfig} prebidConfig={prebidConfig} skipBlockthrough>
      {children}
    </AdsWrapper>
  )
}
